export default {
  'profile.multi_factor_authentication_tooltip.title':
    'When logging in with SSO, you will not be prompted to use MFA; even if it is enabled for your account. We defer to the SSO provider to enforce MFA.'
}
